import stockList, { loadResults } from './stock-list.js';
import SymbolForm from '../includes/symbol-form.js';

let form;

function setPrice(price, init = false) {
	document.getElementById('best-stocks-under-price').textContent = price;

	if (init) {
		history.replaceState({ price }, null, `/best-stocks-under-${price}`);
	} else {
		history.pushState({ price }, null, `/best-stocks-under-${price}`);
	}
}

export default async function(res, target) {
	window.addEventListener('popstate', function({ state }) {
		form.set('price', state.price.toString());
	});

	const page = await stockList(res, target);

	form = page.formObj;

	form.setCallback('price', 'set', value => setPrice(value, false));

	setPrice(form.get('price'), true);
};
